import { FC, InputHTMLAttributes, useContext, useEffect, useState } from "react";
import ReactInputMask from "react-input-mask";
import DatePicker from "react-datepicker";
// import {useNavigate} from "react-router-dom";
import { differenceInCalendarDays, format, getYear, isBefore, isSameYear, isValid, parseISO, subMonths } from "date-fns";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { RequestDateOfTreatmentProps, RequestTreatmentNotTreatingApiResponse } from "./types";
import { AuthContext } from "src/context/authContext";
import { isNotKAMUser } from "src/helpers";
import { useNavigate } from "react-router-dom";



const RequestDateOfTreatment: FC<RequestDateOfTreatmentProps> = ({ isModalVisible, caseId, hideModal, prescriptionId ,refreshListing, bentype, investigated_at,title}): JSX.Element => {
  
  //console.log("ben Type.....",bentype," title",title)
  const [treatmentDate, changeTreatmentDate] = useState<Date | null>(null);
  const [isInvalid, setInvalidStatus] = useState<boolean>(false);
  const { isManufacturer,userData } = useContext(AuthContext)

  const { loading: requestTreatmentLoading, data: requestTreatmentData, mutate: updateRequestTreatment, error: treatmentUpdateError } = useFetch<RequestTreatmentNotTreatingApiResponse>(APIEndpoints.REQUEST_TREATMENT_NOT_TREATING, {}, { caseId, prescriptionId })
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (treatmentDate) {
      if (isInvalid) setInvalidStatus(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentDate])

  const isTreatmentBeforeInvestigation = (dateToCompare: Date) => {
    if (!investigated_at) return false;
    const parsedDate = parseISO(investigated_at);
    if (!isValid(parsedDate)) return false;
    return isBefore(dateToCompare, parsedDate);
  };

  const isTreatmentMoreThan14DaysBeforeInvestigation = (dateToCompare: Date) => {
    if (!investigated_at) return false;
    const parsedDate = parseISO(investigated_at);
    if (!isValid(parsedDate)) return false;
    return differenceInCalendarDays(parsedDate, dateToCompare) > 14;
  };

  const manageTreatmentDateBlur = (date?: Date) => {
    console.log("Date on Blur.....",date, treatmentDate)
    // if (date) {
    //   if (isTreatmentMoreThan14DaysBeforeInvestigation(date)) {
    //     alert("WARNING: This date is more than 14 days before the investigation date. Please contact MQC to make this change.");
    //     changeTreatmentDate(null);
    //   } else if (isTreatmentBeforeInvestigation(date)) {
    //     alert("WARNING: This date is before the investigation date. Are you sure?");
    //   }
    // } else 
    if (!isManufacturer) {
      if (bentype !== "med") {
        if (treatmentDate) {
          if (isTreatmentMoreThan14DaysBeforeInvestigation(treatmentDate)) {
            alert("WARNING: This date is more than 14 days before the investigation date. Please contact MQC to make this change.");
            changeTreatmentDate(null);
          } else if (isTreatmentBeforeInvestigation(treatmentDate)) {
            alert("WARNING: This date is before the investigation date. Are you sure?");
          }
        }
      }
    }
  }

  const submitForm = () => {
    // console.log("Treatment Date.....",treatmentDate  , treatmentDate && format(treatmentDate, "yyyy-MM-dd"))
    if (treatmentDate) {
      if ((bentype === 'sd') && !isSameYear(new Date(treatmentDate), new Date())) {
        alert(`Event date must be between January 1, ${getYear(new Date())} and December 31, ${getYear(new Date())}`);
        changeTreatmentDate(null);
        return;
      }

      if(bentype==='sd') {
        const requestBody = {
          "prescription": {
            "bentype": bentype,
            "scheduled_treatment": format(treatmentDate, "yyyy-MM-dd")
          }
        }
        updateRequestTreatment(requestBody)
      }else if(bentype==='med'){
        const requestBody = {
          "prescription": {
            "bentype": bentype,
            ...(typeof investigated_at === "string" ? { investigated_at } : {}),
            "scheduled_date_of_service": format(treatmentDate, "yyyy-MM-dd")
          }
        }
        updateRequestTreatment(requestBody)
      }
      else if(bentype==='na'){
        const requestBody = {
          "prescription": {
            "bentype": bentype,
            ...(typeof investigated_at === "string" ? { investigated_at } : {}),
            "scheduled_date_of_service": format(treatmentDate, "yyyy-MM-dd")
          }
        }
        updateRequestTreatment(requestBody)
      }
      else if(bentype==='non'){

        const requestBody = {
          "prescription": {
            "bentype":bentype,
            "scheduled_treatment": format(treatmentDate, "yyyy-MM-dd")
          }
        }
        updateRequestTreatment(requestBody)
      }
    } else {
      setInvalidStatus(true)
    }
  }

  useEffect(() => {
    if (requestTreatmentData || treatmentUpdateError) {
      changeTreatmentDate(null)
      hideModal()
      if(requestTreatmentData) {
        const { code } = requestTreatmentData;
        if (code === 200) {
          showToast([`Request Treatment Scheduled Successfully`], ToastTypes.SUCCESS);
          // removeErrorAndData()
         ((userData && isNotKAMUser(userData.ref_type)) ? refreshListing() : navigate(0))
          // navigate(0)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestTreatmentData, treatmentUpdateError]);

  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
      onClick={hideModal}
    >
      <div className="modal-dialog modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h4 className={`modal-title ${bentype === "med" ? "text-success" : ""}`}>
             {bentype === "sd"  ? `Case ${caseId} Scheduled Date of Treatment` : ["na"].includes(bentype ?? '') ? `Case ${caseId} ${title ? title : "Date of Treatment"}` : bentype === "med" ? `Case ${caseId} ${title ? title : "Treated"}` : `Case ${caseId} ${title ? title : "Scheduled Date of Treatment" } ` }
            </h4>
            <button type="button" className="btn-close" aria-label="Close" onClick={hideModal}></button>
          </div>

          <div className="modal-body">
            <p className="text-center mb-3">{["na", "med"].includes(bentype ?? '') ? "Please specify date of treatment..." : "Please specify scheduled date of treatment..."} </p>

            <div className="row mx-3">
              <label htmlFor="treatmentDate" className="form-label col-3"> Date * </label>
              <div className="col-9">
                <DatePicker
                    selected={treatmentDate}
                    onChange={(date) => {
                      changeTreatmentDate(date);
                      // if (date) manageTreatmentDateBlur(date);
                    }}
                    dateFormat="MM/dd/yyyy"
                    className={`form-control ${isInvalid ? "is-invalid" : ""}`}
                    placeholderText="mm/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    customInput={
                      <ReactInputMask mask="99/99/9999">
                        {(inputProps: InputHTMLAttributes<HTMLInputElement>) => (
                          <input
                            {...inputProps}
                          />
                        )}
                      </ReactInputMask>
                    }
                    onCalendarClose={manageTreatmentDateBlur}
                    minDate={["med"].includes(bentype ?? '') ? subMonths(new Date(), 6) : undefined}
                    maxDate={["na", "med"].includes(bentype ?? '') ? new Date() : bentype === "na" ? new Date() : undefined}
                    wrapperClassName="w-100"
                    onBlur={manageTreatmentDateBlur as unknown as React.FocusEventHandler<HTMLDivElement>}
                />
                {isInvalid && (
                  <p className="mb-0 text-danger pt-1">Date is required</p>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button disabled={requestTreatmentLoading} type="button" className="btn btn-blue px-4" data-bs-dismiss="modal" onClick={submitForm}>
              {requestTreatmentLoading ? (<i className="spinner-border me-2"></i>) : null}
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestDateOfTreatment;
